import Coffee from "../images/projects/coffee-house.png";
import burgerBuilder from "../images/projects/burger-builder.png";
import evenlay from "../images/projects/evenlay.png";
import xion from "../images/projects/xion.png";
import wePost from "../images/projects/we-post.png";
import gmailClone from "../images/projects/gmail-clone.png";
import expenseTracker from "../images/projects/expense.png";
import HTMLImg from "../images/skills/html.png";
import CSSImg from "../images/skills/css.png";
import JSImg from "../images/skills/js.jpg";
import FirebaseLogo from "../images/skills/firebase_logo.png";
import MaterialIcon from "../images/skills/mui.png";
import ReactImg from "../images/skills/react.png";
import ReduxImg from "../images/skills/redux.png";
import FigmaImg from "../images/skills/figma.png";
import SaasImg from "../images/skills/saasImg.png";
import SolidityImg from "../images/skills/solidity.png";
import HardhatImg from "../images/skills/hardhat.png";
import TruffleImg from "../images/skills/truffle.png";
import NextjsImg from "../images/skills/nextjs.png";
import NodeJSImg from "../images/skills/nodejs1.png";

import DegenHouseImg from "../images/projects/degenhouse.png";
import JananiNFTImg from "../images/projects/janani.png";
import BooksmandalaImg from "../images/projects/booksmandala.png";
import GweiStationImg from "../images/projects/gweistation.png";
import BizmandalaImg from "../images/projects/bizmandala.png";

export const projectIhaveBeenPartOf = [
    {
        id: 1,
        title: "DegenHouse",
        description:
            "Diverse offerings in cryptocurrency,NFT betting,lottries, and advanced price prediction markets.",
        projectLink: "https://testnet.degenhouse.xyz/",
        github: "",
        image: DegenHouseImg,
        tags: ["Solidity", "Chainlink", "Gelato", "Alchemy"],
    },
    {
        id: 2,
        title: "Janani NFTs",
        description:
            "Janani NFTs are  vibrant tribute to inclusivity and diversity in the world of web3, inspired by traditional folk art form.",
        projectLink: "https://jananinft.art/",
        github: "",
        image: JananiNFTImg,
        tags: ["Solana", "CandyMachine", "NextJs"],
    },
    {
        id: 3,
        title: "Booksmandala",
        description:
            "Booksmandala is the largest online book store in Nepal. It provides a smooth shopping experience",
        projectLink: "https://booksmandala.com/",
        github: "",
        image: BooksmandalaImg,
        tags: ["NextJs", "Redux", "E-commerce"],
    },
    {
        id: 4,
        title: "GweiStation",
        description:
            "Discover crypto airdrops, tracking gas prices, and seizing opportunities for free crypto airdrops.",
        projectLink: "https://gweistation.io/",
        github: "",
        image: GweiStationImg,
        tags: ["NextJs", "Alchemy", "Airdrops", "Gas"],
    },
];

export const vanillajsProjects = [
    {
        id: 2,
        title: "Evanley",
        description:
            "The website is about a architecture company. An effort to build a clean and professional website.The project includes some javascript components as carousel, hamburger menu , accordian ,counter.",
        projectLink: "https://evenlay.netlify.app/",
        github: "https://github.com/Anjan-poudel-1/Evanlay",
        image: evenlay,
    },
    {
        id: 1,
        title: "Coffee House",
        description:
            "Welcome to Coffee House. My first website built on vanilla js. A simple website created by including some components like carousel, form validation ,testemonials. Wireframe, UI-Design was built on Figma.",
        projectLink: "https://coffeehouse1.netlify.app/",
        github: "https://github.com/Anjan-poudel-1/IT-website-final",
        image: Coffee,
    },
];

export const reactProjects = [
    {
        id: 4,
        title: "Burger Builder",
        description:
            "The elements of burger are built in css. We can create and order burger according to our need. With the use of firestore, data of user on form submission and the details of burger ordered is kept. Authentication is not yet built.  ",
        projectLink: "https://react-burger-67bef.web.app/",
        github: "https://github.com/Anjan-poudel-1/Burger-builder",
        tags: ["Redux", "Firestore"],
        image: burgerBuilder,
    },
    {
        id: 6,
        title: "We Post",
        description:
            "A small step towards creating a social platform. We can login with the help of google.",
        projectLink: "https://wepost-9d1ef.web.app/",
        github: "https://github.com/Anjan-poudel-1/We-post",
        tags: ["Google Authentication", "Firestore Storage", "Firestore "],
        image: wePost,
    },
    {
        id: 3,
        title: "Expense Tracker",
        description:
            "A small CRUD application developed in react. User can track their income and expense with the help of this. Also there is an option to toggle between light and dark mode. ",
        projectLink: "https://track-our-expense.netlify.app/",
        github: "https://github.com/Anjan-poudel-1/Expense-Tracker",
        tags: ["Material-UI", "Context-API"],
        image: expenseTracker,
    },

    {
        id: 7,
        title: "Xion Movies",
        description:
            "With the help of MovieDB API, the web app displays movies and series. TV and movies can be fitered according to given tags. A user can search for movie or series and as well add them to wishlist so that they can watch it later.",
        projectLink: "https://xion-movies.netlify.app/",
        github: "https://github.com/Anjan-poudel-1/xionMovies",
        tags: ["Local Storage", "Redux", "MovieDB API", "Material UI-theme"],
        image: xion,
    },
    {
        id: 8,
        title: "Gmail Clone",
        description:
            "This is an effort to make clone of gmail service. User can login with google and can compose, send emails to other user. Emails sent and received are separated. Also, We can star important mails . Unfortunately the web app is not mobile friendly.",
        projectLink: "https://clone-eb201.web.app/",
        github: "https://github.com/Anjan-poudel-1/gmail-clone",
        tags: [
            "Google Authentication",
            "Firestore",
            "Redux",
            "Firebase Storage",
        ],
        image: gmailClone,
    },
];

export const socialMediaLinks = {
    facebook: "https://www.facebook.com/anjan.poudel.12",
    instagram: "https://www.instagram.com/anjan__poudel/",
    linkedin: "https://www.linkedin.com/in/anjan-poudel-2817a9201/",
    github: "https://github.com/Anjan-poudel-1",
};
let heightValue = "40px";
let widthValue = "42px";
export const skills = [
    {
        id: 1,
        name: "html",
        imageURL: HTMLImg,
        height: heightValue,
    },
    {
        id: 2,
        name: "css",
        imageURL: CSSImg,
        height: heightValue,
    },
    {
        id: 3,
        name: "javascript",
        imageURL: JSImg,
        height: heightValue,
    },

    {
        id: 5,
        name: "react js",
        imageURL: ReactImg,
        width: widthValue,
    },
    {
        id: 15,
        name: "next js",
        imageURL: NextjsImg,
        width: widthValue,
    },
    {
        id: 15,
        name: "node js",
        imageURL: NodeJSImg,
        width: widthValue,
    },
    {
        id: 16,
        name: "solidity",
        imageURL: SolidityImg,
        width: widthValue,
    },
    {
        id: 6,
        name: "material-ui",
        imageURL: MaterialIcon,
        height: heightValue,
    },
    {
        id: 4,
        name: "SAAS",
        imageURL: SaasImg,
        height: heightValue,
    },
    {
        id: 7,
        name: "redux",
        imageURL: ReduxImg,
        width: widthValue,
    },
    {
        id: 14,
        name: "Hardhat",
        imageURL: HardhatImg,
        height: heightValue,
    },
    {
        id: 18,
        name: "Truffle",
        imageURL: TruffleImg,
        height: heightValue,
    },
    {
        id: 8,
        name: "firebase",
        imageURL: FirebaseLogo,
        height: heightValue,
    },
    {
        id: 9,
        name: "figma",
        imageURL: FigmaImg,
        height: heightValue,
    },
];
